module.exports = __webpack_public_path__ + "static/media/Table1.c22c57db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Table1.jpg
// module id = 149
// module chunks = 0